import React from 'react'
import ReactGA from 'react-ga'
import { browserHistory } from 'react-router' 
import MediaQuery from 'react-responsive'
import classes from './Game.scss'
import Alphabet from '../Alphabet/Alphabet'
import TextInput from '../TextInput'
import Button from '../Button'
import JottoGame from './jotto_game.png'
import Cloud from './cloud.png'
import Avatar from './avatar3.png'
import GameOver from './GameOver'
import 'whatwg-fetch'

const SPECIAL_WORDS = ['giveup']

export default class Game extends React.Component {

  constructor (props) {
    super(props)

    this.state = {
      gameId: undefined,
      matches: undefined,
      score: 100,
      enemyName: undefined,
      enemyScore: undefined,
      multiplayer: undefined,
      word: '',
      sentWord: '',
      guesses: [],
      enemyGuesses: [],
      won: false,
      lost: false,
      timerId: undefined,
      alphabet: {},
      enemyWon: false,
      enemyForfeit: false,
      sending: false,
      optionsOpen: false,
    }

    const self: any = this
    self.trySendGuess = self.trySendGuess.bind(self)
    self.sendGuess = self.sendGuess.bind(self)
    self.textChange = self.textChange.bind(self)
    self.addGuess = self.addGuess.bind(self)
    self.updateEnemyCount = self.updateEnemyCount.bind(self)
    self.startCountUpdates = self.startCountUpdates.bind(self)
    self.stopCountUpdates = self.stopCountUpdates.bind(self)
    self.toggleOptions = self.toggleOptions.bind(self)
    self.clearAlphabet = self.clearAlphabet.bind(self)
    self.giveUp = self.giveUp.bind(self)
  }

  componentDidMount () {
    const { baseUrl, params, username, openAlertModal } = this.props
    window.scrollTo(0, 0)
    if (params.gameId) {
      fetch(`${baseUrl}/games/${params.gameId}`, { credentials: 'include' })
        .then(res => res.json())
        .then(res => {
          if (res.result === 'ok') {
            const lastGuess = res.guesses[res.guesses.length - 1]
            let sentWord = res.target
            let matches
            if (lastGuess && !sentWord) {
              sentWord = lastGuess.word
              matches = lastGuess.matches
            }
            const multiplayer = res.multiplayer
            if (multiplayer && !res.enemyWon && !res.enemyForfeit) {
              this.startCountUpdates()
            }
            this.setState({ gameId: params.gameId, score: res.score, guesses: res.guesses, alphabet: res.alphabet, sentWord, matches, won: res.won, lost: res.forfeit, enemyName: res.enemyName, enemyScore: res.enemyScore, multiplayer, enemyWon: res.enemyWon, enemyForfeit: res.enemyForfeit, enemyGuesses: res.enemyGuesses })
            ReactGA.event({ category: 'Game', action: 'Resumed game' })
          } else {
            // alert('some error occured: ', res.msg)
            openAlertModal('Sorry! Game expired. Create an account to keep your games.')
            // console.log('error', res)
            browserHistory.push('/list_solo')
          }
        })
    } else {
      fetch(`${baseUrl}/games/new`, { credentials: 'include' })
       .then(res => res.json())
       .then(res => {
         const { gameId } = res
         this.setState({ gameId })
         browserHistory.push(`/game/${gameId}`)
         ReactGA.event({ category: 'Game', action: 'Started game' })
       })
       .catch(err => console.log('error starting game: ', err))
    }
  }

  componentWillUnmount () {
    this.stopCountUpdates()
  }

  stopCountUpdates () {
    const { timerId } = this.state
    if (timerId) {
      clearInterval(timerId)
    }
  }

  startCountUpdates () {
    const timerId = setInterval(this.updateEnemyCount, 3000)
    this.setState({ timerId })
  }

  updateEnemyCount () {
    const { baseUrl } = this.props
    const { gameId } = this.state
    fetch(`${baseUrl}/game/${gameId}/counts`, { credentials: 'include' })
      .then(res => res.json())
      .then(res => {
        if (res.result === 'ok') {
          const { enemyScore, enemyWon, enemyForfeit, enemyGuesses } = res
          if (enemyWon || enemyForfeit) {
            this.stopCountUpdates()
          }
          this.setState({ enemyScore, enemyWon, enemyForfeit, enemyGuesses })
        }
      })
  }

  trySendGuess (e) {
    if (e.keyCode === 13) {
      this.sendGuess()
    }
  }

  addGuess (word, matches) {
    const { guesses } = this.state
    guesses.push({ word, matches })
    document.getElementById('guessBox').scrollTop = 0
  }

  sendGuess (text) {
    const { gameId, sending } = this.state
    let word = text || this.state.word
    if (sending) return
    const { baseUrl, openAlertModal } = this.props
    this.setState({ word: '' })
    if (word === 'changemyblame') { return alert('eat my dame!') }
    const sanitizedWord = word.toLowerCase()
    if (sanitizedWord.length !== 5 && !SPECIAL_WORDS.includes(sanitizedWord)) return openAlertModal('lets do this together.. 1... 2... 3... 4... 5!')

    this.setState({ sending: true })
    fetch(`${baseUrl}/game/${gameId}/play/${sanitizedWord}`, { credentials: 'include' })
      .then(res => res.json())
      .then(res => {
        const { err, matches, score, win, target, enemyGuesses } = res
        // document.getElementById('guessText').focus()
        if (err) {
          openAlertModal('Error: ' + err)
          ReactGA.event({ category: 'Game', action: 'Failed guess', label: err })
        } else {
          ReactGA.event({ category: 'Game', action: 'Sent guess' })
          this.addGuess(sanitizedWord, matches)
          this.setState({ matches, score, sentWord: sanitizedWord })
          if (win) {
            openAlertModal('Good job!')
            this.setState({ won: score, enemyGuesses })
            ReactGA.event({ category: 'Game', action: 'Won game' })
          } else if (target) {
            this.setState({ lost: true, sentWord: target, matches: undefined })
          }
        }
        this.setState({ sending: false })
      })
      .catch(err => console.log('error sending guess: ', err))
  }

  textChange (e) {
    const word = e.target.value
    this.setState({ word })
  }

  renderGuess (guess, idx) {
    const { word, matches } = guess
    // return (<span className={classes.guessLine}>{word} - {matches}</span>)
    return (<li key={idx}>{word} <span>{Number.isInteger(matches) && matches}</span></li>)
  }

  clearAlphabet () {
    const { baseUrl } = this.props
    const { gameId } = this.state

    if (!confirm('Are you sure?')) return

    fetch(`${baseUrl}/game/${gameId}/clear`, { credentials: 'include' })
      .then(res => res.json())
      .then(res => {
        const { err, result, alphabet } = res
        
        if (err) { alert('Error!'); return console.log(err) }
        this.setState({ alphabet: 'clear' })
        this.setState({ alphabet: {} })
      })
  }

  giveUp () {
    if (!confirm('Are you sure?')) return
    this.sendGuess('giveup')
  }

  toggleOptions () {
    const { optionsOpen } = this.state
    this.setState({ optionsOpen: !optionsOpen })
  }

  render () {
    const { matches, word, sentWord, score, enemyScore, guesses, gameId, alphabet, multiplayer, enemyWon, enemyForfeit,
      sending, enemyName, optionsOpen, enemyGuesses } = this.state
    const { baseUrl, username } = this.props

    let won = this.state.won
    let lost = this.state.lost
    let waiting = false
    if (multiplayer && (won || lost)) {
      waiting = !enemyWon && !enemyForfeit
      won = !lost && (won && (score >= enemyScore) || enemyForfeit) 
      lost = (lost || (score < enemyScore && !enemyForfeit))
    }

    const scoreBoxClasses = [classes.scoreBox, multiplayer && classes.multiplayer].join(' ')
    const sendBtnClasses = [classes.sendBtn, sending && classes.disabled].join(' ')

    return (
      <div style={{marginBottom: '1em'}}>
        <div className={classes.gameScreen}>
          <Alphabet baseUrl={baseUrl} gameId={gameId} alphabet={alphabet} username={username} />
          <div className={classes.lastGuess}>
            <MediaQuery className={classes.littleJotto} component={'div'} maxWidth={900}>
              <img src={JottoGame} />
            </MediaQuery>
            <h3>{sentWord || 'Make a Guess'}</h3>
            {Number.isInteger(matches) && <h3>{matches}</h3>}
            <hr />
          </div>
          {!won && !lost && !waiting && <div className={classes.inputBox}>
            <TextInput id='guessText' onChange={this.textChange} onKeyUp={this.trySendGuess} value={word} />
            <br />
            <Button value='Guess!' onClick={() => this.sendGuess()} className={sendBtnClasses} /><br />
            
            {!optionsOpen && <span onClick={this.toggleOptions} className={classes.optionBtn}><i className="fa fa-plus-square" aria-hidden="true" style={{marginRight: '0.25em'}}></i>Options</span>}
            {optionsOpen && <div className={classes.optionBox}>
              <Button value='Reset Board' onClick={this.clearAlphabet} className={classes.smallBtn} style={{marginRight: '5px'}} />
              <Button value='Give up' onClick={this.giveUp} className={classes.smallBtn} />
            </div>}
          </div>}
          {!waiting && (won || lost) && <GameOver baseUrl={baseUrl} target={sentWord} score={score} guesses={guesses} mode={multiplayer ? 'multi' : 'solo'} enemyName={enemyName} enemyScore={enemyScore} enemyGuesses={enemyGuesses} />}
          {!waiting && (won || lost) && <h2>You {won ? 'won' : 'lost'}!!!</h2>}
          {waiting && <div className={classes.waitingCloud} >
            <img src={Cloud} />
            <h3 className={classes.winText}>Waiting...</h3>
          </div>}
          <div className={scoreBoxClasses}>
            {multiplayer && <div className={classes.enemyFace}>
              <span className={classes.enemyName}>{enemyName}</span>
              <img src={Avatar} />
            </div>}
            <h4>Score{multiplayer && 's'}</h4>
            <div className={[classes.scoreHolder, multiplayer && classes.hasEnemy, waiting && classes.winner].join(' ')}>
              <span>{score}</span>
            </div>
            {multiplayer && <div className={[classes.scoreHolder, classes.enemy, enemyWon && classes.winner].join(' ')}>
              <span>{enemyScore}</span>
            </div>}
          </div>
          <MediaQuery component={'div'} className={classes.mrJotto} minWidth={900}>
            <img src={JottoGame} />
          </MediaQuery>
          <h4 className={classes.guessCount}>Guesses: {guesses.length}</h4>
          <ul id='guessBox' className={classes.guesses}>
            {[...guesses].reverse().map(this.renderGuess.bind(this))}
          </ul>
        </div>
        <div className={classes.overlay} />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Game/Game.js
 **/